import * as Dialog from '@radix-ui/react-dialog';
import { VisuallyHidden } from '@radix-ui/react-visually-hidden';

// Drawer — right-side slide-over, max 380px.
// For settings panels and view-options only. Full-entity drawers use the existing
// AsinDrawer/ClientDrawer patterns (which are not modal).
export function Drawer({
  open,
  onOpenChange,
  title,
  subtitle,
  description,
  children,
  footer,
  width = 380,
}) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay
          className="fixed inset-0 bg-sitruna-black/30 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
          style={{ zIndex: 'var(--z-drawer)' }}
        />
        <Dialog.Content
          className="fixed right-0 top-0 h-full bg-white shadow-3 flex flex-col focus:outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right duration-200"
          style={{ width: `min(${width}px, 100vw)`, zIndex: 'var(--z-drawer)' }}
        >
          {/* Header */}
          <div className="flex items-start justify-between px-5 py-4 border-b border-n-100 shrink-0">
            <div className="min-w-0">
              <Dialog.Title className="text-[15px] font-semibold text-n-800 leading-tight">
                {title}
              </Dialog.Title>
              {subtitle && (
                <div className="text-[11.5px] text-n-500 mt-0.5 truncate">{subtitle}</div>
              )}
            </div>
            <Dialog.Close asChild>
              <button
                type="button"
                aria-label="Close"
                className="w-7 h-7 flex items-center justify-center rounded text-n-400 hover:text-n-700 hover:bg-n-50 transition-colors shrink-0"
              >
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
                  <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
                </svg>
              </button>
            </Dialog.Close>
          </div>

          {/* Body */}
          <div className="flex-1 overflow-y-auto px-5 py-4">
            {description && (
              <Dialog.Description className="text-sm text-n-500 mb-4">
                {description}
              </Dialog.Description>
            )}
            {!description && <VisuallyHidden><Dialog.Description>Drawer content</Dialog.Description></VisuallyHidden>}
            {children}
          </div>

          {footer && (
            <div className="px-5 py-3 border-t border-n-100 shrink-0">{footer}</div>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export function DrawerClose({ children }) {
  return <Dialog.Close asChild>{children}</Dialog.Close>;
}
